'use strict';

angular.module('user')
    .controller('RecoverPasswordFormController', ['$q', 'AccountManager', 'ShareCrfApiErrorCodes', function($q, AccountManager, ShareCrfApiErrorCodes) {
        var vm = this;

        vm.data = {};

        vm.error = false;
        vm.submitted = false;
        vm.running = false;

        /**
         * Submit form
         *
         * @param {Form}
         *
         * @return {Promise}
         */
        vm.submit = function(form) {
            vm.submitted = true;

            var promise = $q.resolve();

            if (form.$valid) {
                vm.running = true;

                promise = AccountManager.recoverPasswordRequest(vm.data.email)
                    .then(function() {
                        vm.running = false;

                        return vm.onSubmit();
                    })
                    .catch(function(error) {
                        vm.running = false;
                        vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                    });
            }

            return promise;
        };
    }]);
